export default {
  methods: {
    removeHtmlTags(text) {
      return String(text).replace(/(<([^>]+)>)/ig, '');
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/removeHtmlTags.js